module.exports = __webpack_public_path__ + "static/media/get-it-on-app-store.6c7b8c7b.svg";